<div class="h-full flex flex-col">
  <div class="flex grow min-h-0 gap-2 mt-3">
    <div *ngIf="items.length" class="sidebar-wrapper" [class.collapsed]="isSidebarCollapsed">
      <div class="sidebar-toggle" (click)="toggleSidebar()" [title]="isSidebarCollapsed ? 'Expand menu' : 'Collapse menu'">
        <i class="pi" [class.pi-angle-left]="!isSidebarCollapsed" [class.pi-angle-right]="isSidebarCollapsed"></i>
      </div>
      <div class="sidebar-container">
        <p-panelMenu styleClass="layout-submenu" [model]="items" [multiple]="true"></p-panelMenu>
      </div>
    </div>
    <div class="grow flex flex-col min-h-0 ml-4">
      <app-pending-cancellations-tray></app-pending-cancellations-tray>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
